import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  term: Yup.number()
    .required('BUREAU_FORM.STEP_ZERO.TERM_REQUIRED')
    .min(12, 'BUREAU_FORM.STEP_ZERO.TERM_MIN')
    .max(72, 'BUREAU_FORM.STEP_ZERO.TERM_MAX')
});

export default validationSchema;
